<div class="text-center">
    <img class="mb-2" src="assets/logoWIKAMP.png" style="height:7rem">
    <h2>{{langStrings['redirect-begin']}} {{redirectTimeSeconds}} {{langStrings['redirect-end']}}</h2>
    <h5>{{langStrings['troubles-start']}} <a href="{{redirectURL}}">{{langStrings['troubles-end']}}</a>.</h5>
</div>

<meta http-equiv="refresh" content="{{redirectTimeSeconds}};url={{redirectURL}}" />